export class ClientConfigService {
    Configuration = {
        successMsgPopupDuration: 1000,
        failMsgPopupDuration: 1000,        
        baseAppCoreApi: '',
        appStoreUrl: ''
    };

    AppEncryptConfig = {
        AppCore: ''
    };

    constructor() {}
}